import classes from './ArticleSource.module.css'

const ArticleSource = ({ source, referer = '' }) => {
  return (
    <a
      href={referer}
      target="_blank"
      rel="noopener noreferrer"
      className={`${classes['article-source']}`}
    >
      {source}
    </a>
  )
}

export default ArticleSource
